import { useEffect } from "react";
import { Link } from "react-router-dom";
import PartnerDisclosure from "../../components/automap/partnerships/PartnerDisclosure";
import {
  PARTNERSHIP_ANALYTICS_EVENTS,
  SERVICE_PAGE_CONFIG,
  getCategoryLabel,
  getServicePath,
} from "../../constants/automapPartnershipConstants";
import { trackPartnershipEvent } from "../../services/automapPartnershipApi";
import "../../styles/partnerships.css";

const HUB_CATEGORIES = ["financing", "insurance", "soat", "inspection", "transfer_service"];

export default function ServicesHubPage() {
  useEffect(() => {
    document.title = "Servicios para compradores | AutoMapa";
    trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CARD_VIEWED, {
      sourcePage: "/servicios",
    });
  }, []);

  return (
    <div className="partnerships-page">
      <header className="partnerships-page__hero">
        <div className="wrap">
          <span className="partnerships-page__eyebrow">AutoMapa · Servicios</span>
          <h1>Servicios que pueden ayudarte al comprar</h1>
          <p>
            AutoMapa puede conectar tu solicitud con aliados externos para financiación, seguro, SOAT,
            peritaje o traspaso. Las condiciones dependen del proveedor — no garantizamos resultados.
          </p>
        </div>
      </header>
      <main className="partnerships-page__main">
        <div className="partnerships-grid">
          {HUB_CATEGORIES.map((category) => {
            const cfg = SERVICE_PAGE_CONFIG[category];
            return (
              <article key={category} className="partnerships-card">
                <h2>{getCategoryLabel(category)}</h2>
                <p>{cfg?.hero || "Solicita información con un aliado."}</p>
                <div className="partnerships-card__actions">
                  <Link
                    className="partnerships-btn partnerships-btn--primary"
                    to={getServicePath(category)}
                    onClick={() =>
                      trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CTA_CLICKED, {
                        category,
                        sourcePage: "/servicios",
                        sourceAction: "request_info",
                      })
                    }
                  >
                    Solicitar información
                  </Link>
                  <Link className="partnerships-btn partnerships-btn--soft" to={getServicePath(category)}>
                    Ver guía
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
        <PartnerDisclosure category="financing" />
      </main>
    </div>
  );
}
